export const MOBILE_BURGER_MENU_LEFT_OFFSET = 5
export const MOBILE_BURGER_MENU_TOP_OFFSET = 5
export const MOBILE_BURGER_MENU_SIZE = 32
